import { AgendamientoGuarderiaResumido } from "../../services/agendamientosGuarderiaServicios";
import { Badge, Row } from "react-bootstrap";
import { currencyFormat } from "../../utils/numberUtils";
import ExtensionIcon from "@mui/icons-material/Extension";
import { InfoRow } from "./components/InfoRow";
import { ListaFechas } from "./components/ListaFechas";
import { DatosTransporte } from "./components/DatosTransporte";
import { SectionTitle } from "./components/SectionTitle";
import { IconContainer } from "./components/IconContainer";
import DirectionsBusIcon from "@mui/icons-material/DirectionsBus";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import PaidIcon from "@mui/icons-material/Paid";

export const AgendamientoResumidoGuarderia = ({
  agendamiento,
}: {
  agendamiento: AgendamientoGuarderiaResumido;
}) => {
  const contrataTransporteIda = !!agendamiento.reservaTransporteIda;

  const contrataTransporteVuelta = !!agendamiento.reservaTransporteVuelta;

  const contrataTransporteIdaVuelta = !!agendamiento.reservaTransporteIdaVuelta;

  const contrataTransporte =
    contrataTransporteIda ||
    contrataTransporteVuelta ||
    contrataTransporteIdaVuelta;

  const reservaGuarderia = agendamiento.reservaGuarderia;
  const fechasGuarderia = agendamiento.reservaGuarderia.fechasProgramadas;
  return (
    <div>
      <h5>
        <IconContainer>
          <ExtensionIcon />
        </IconContainer>
        Agendamiento de Guardería
        {
          !agendamiento.estaActivo && (
            <Badge bg="danger" pill className="m-2">
              Inactiva
            </Badge>
          )
        }
      </h5>
      <section className="mt-3">
        <div>
          <label className="mb-2 fw-bold" style={{ fontWeight: 500 }}>
            <IconContainer>
              <CalendarMonthIcon />
            </IconContainer>
            Fechas programadas:
          </label>
          <ListaFechas fechas={fechasGuarderia} />
        </div>
      </section>
      {contrataTransporte && (
        <section>
          {contrataTransporteIda && (
            <div className="mb-4">
              <SectionTitle className="mb-3">
                <IconContainer>
                  <DirectionsBusIcon />
                </IconContainer>
                Datos de transporte de ida
              </SectionTitle>
              <DatosTransporte
                reservaTransporte={agendamiento.reservaTransporteIda!}
              />
            </div>
          )}
          {contrataTransporteVuelta && (
            <div className="mb-4">
              <SectionTitle className="mb-3">
                <IconContainer>
                  <DirectionsBusIcon />
                </IconContainer>
                Datos de transporte de vuelta
              </SectionTitle>
              <DatosTransporte
                reservaTransporte={agendamiento.reservaTransporteVuelta!}
              />
            </div>
          )}
          {contrataTransporteIdaVuelta && (
            <div className="mb-4">
              <SectionTitle className="mb-3">
                <IconContainer>
                  <DirectionsBusIcon />
                </IconContainer>
                Datos de transporte de ida y vuelta
              </SectionTitle>
              <DatosTransporte
                reservaTransporte={agendamiento.reservaTransporteIdaVuelta!}
              />
            </div>
          )}
        </section>
      )}

      <section className="mb-4">
        <SectionTitle className="mb-3">
          <IconContainer>
            <PaidIcon />
          </IconContainer>
          Tarifas y planes
        </SectionTitle>
        {reservaGuarderia.plan && (
          <div className="mb-4">
            <InfoRow label="Plan" value={reservaGuarderia.plan!} />
            <InfoRow
              label="Valor final plan"
              value={currencyFormat(reservaGuarderia.precioFinalPlan!)}
            />
          </div>
        )}

        {reservaGuarderia.servicioDiaIndividual && (
          <div className="mb-4">
            <InfoRow
              label="Días individuales"
              value={`${reservaGuarderia.diasIndividuales!}`}
            />
            <InfoRow
              label="Tarifa día individual"
              value={reservaGuarderia.servicioDiaIndividual}
            />
            <InfoRow
              label="Valor final día individual"
              value={currencyFormat(reservaGuarderia.precioFinalDiaIndividual!)}
            />
          </div>
        )}

        {contrataTransporteIda && (
          <Row className="mb-4">
            <InfoRow
              label="Número días transporte ida"
              value={`${
                agendamiento.reservaTransporteIda!.fechasProgramadas.length
              }`}
            />
            <InfoRow
              label="Valor servicio transporte ida"
              value={currencyFormat(
                agendamiento.reservaTransporteIda!.precioFinalTarifa
              )}
            />
          </Row>
        )}
        {contrataTransporteVuelta && (
          <Row className="mb-4">
            <InfoRow
              label="Número días transporte vuelta"
              value={`${
                agendamiento.reservaTransporteVuelta!.fechasProgramadas.length
              }`}
            />
            <InfoRow
              label="Valor servicio transporte vuelta"
              value={currencyFormat(
                agendamiento.reservaTransporteVuelta!.precioFinalTarifa
              )}
            />
          </Row>
        )}
        {contrataTransporteIdaVuelta && (
          <Row className="mb-4">
            <InfoRow
              label="Número días transporte ida y vuelta"
              value={`${
                agendamiento.reservaTransporteIdaVuelta!.fechasProgramadas
                  .length
              }`}
            />
            <InfoRow
              label="Valor servicio transporte ida y vuelta"
              value={currencyFormat(
                agendamiento.reservaTransporteIdaVuelta!.precioFinalTarifa
              )}
            />
          </Row>
        )}
      </section>
    </div>
  );
};
